import { toast } from "react-toastify";
import formErrorsHandler, { formErrorLoading } from "api/global/form-errors-handler";
import defaultErrorHandler from "api/global/default-error-handler";
import {
    jobsGet,
    jobsGetById,
    jobsGetBySupplierId,
    jobCreate,
    jobUpdate,
    jobDelete,
    fetchJobsRequest,
    fetchHelperJobsRequest
} from "api/menu/master-files/job-maintenance/requests";

export const FETCH_JOBS_SUCCESS = "FETCH_JOBS_SUCCESS";
export const FETCH_JOB_BY_ID_SUCCESS = "FETCH_JOB_BY_ID_SUCCESS";

export const JOBS_REQUEST_LOADING = "JOBS_REQUEST_LOADING";
export const JOBS_REQUEST_ERRORS = "JOBS_REQUEST_ERRORS";

export const FETCH_JOBS_LOOKUP_SUCCESS = "FETCH_JOBS_LOOKUP_SUCCESS";
export const FETCH_HELPER_JOBS_LOOKUP_SUCCESS = "FETCH_HELPER_JOBS_LOOKUP_SUCCESS";

export const setLoading = () => ({
    type: JOBS_REQUEST_LOADING
});

export const fetchJobs = (includeInactive = true) => dispatch => {
    dispatch(setLoading());
    jobsGet(includeInactive)
        .then(response => {
            dispatch({
                type: FETCH_JOBS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, JOBS_REQUEST_ERRORS));
        });
};

export const fetchJobById = (id) => dispatch => {
    jobsGetById(id)
        .then(response => {
            dispatch({
                type: FETCH_JOB_BY_ID_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, JOBS_REQUEST_ERRORS));
        });
};

export const fetchJobBySupplierId = (id) => dispatch => {
    jobsGetBySupplierId(id)
        .then(response => {
            dispatch({
                type: FETCH_JOBS_SUCCESS,
                payload: response.data
            });
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, JOBS_REQUEST_ERRORS));
        });
};

export const insertJob = (data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    jobCreate(data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Successfully added new Job "${data.jobNumber}"`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const updateJob = (id, data, callback = false) => dispatch => {
    dispatch(formErrorLoading());
    jobUpdate(id, data)
        .then(() => {
            dispatch(formErrorLoading(false));
            toast(`Job "${data.jobNumber}" has been updated`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(formErrorsHandler(error));
        });
};

export const deleteJob = (id, name, callback = false) => dispatch => {
    dispatch(setLoading());
    jobDelete(id)
        .then(() => {
            toast(`Job "${name}" has been deleted`, {
                type: toast.TYPE.SUCCESS,
            });
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            dispatch(defaultErrorHandler(error, JOBS_REQUEST_ERRORS));
        });
};

export const clearJobs = () => dispatch => {
    dispatch({
        type: FETCH_JOBS_SUCCESS,
        payload: []
    });
};

export const clearSingleJob = () => dispatch => {
    dispatch({
        type: FETCH_JOB_BY_ID_SUCCESS,
        payload: []
    });
};

export const fetchJobsLookup = (retailerIdArr, startDate, endDate, reset = false) => dispatch => {
    if (reset) {
        dispatch({
            type: FETCH_JOBS_LOOKUP_SUCCESS,
            payload: []
        });
        return;
    }
    dispatch(setLoading());
    fetchJobsRequest(retailerIdArr, startDate, endDate)
        .then(response => {
            dispatch({
                type: FETCH_JOBS_LOOKUP_SUCCESS,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch(defaultErrorHandler(error, JOBS_REQUEST_ERRORS));
        });
};

export const fetchHelperJobsLookup = (retailerIdArr, reset = false) => dispatch => {
    if (reset) {
        dispatch({
            type: FETCH_HELPER_JOBS_LOOKUP_SUCCESS,
            payload: []
        });
        return;
    }
    dispatch(setLoading());
    fetchHelperJobsRequest(retailerIdArr)
        .then(response => {
            dispatch({
                type: FETCH_HELPER_JOBS_LOOKUP_SUCCESS,
                payload: response.data
            });
        })
        .catch((error) => {
            dispatch(defaultErrorHandler(error, JOBS_REQUEST_ERRORS));
        });
};
